export enum NumberEntry {
    auto = "AutoNumber",
    fromKeywordField = "FromKeywordField",
    manual = "Manual",
}

export enum DateOffsetType {
    business = "business",
    calendar = "calendar",
}

export interface SubmittalSettings {
    enabled: boolean;
    numberEntryMode: NumberEntry;
    dueDateOffsetInDays: number;
    defaultDueDate: string;
    dueDateOffsetType: DateOffsetType;
    reviewResponseDueDateOffsetInDays: number;
    reviewResponseDueDate: string;
    reviewResponseDueDateOffsetType: string;
}

export interface RfiSettings {
    enabled: boolean;
    numberEntryMode: NumberEntry;
    dueDateOffsetInDays: number;
    defaultDueDate: string;
    dueDateOffsetType: DateOffsetType;
    reviewResponseDueDateOffsetInDays: number;
}

export interface ActionItemSettings {
    enabled: boolean;
}

export interface TransferSettings {
    allowPartialDownload: boolean;
    defaultExpireDays: number;
    enabled: boolean;
    requireNixLoginForDownload: boolean;
    transferExpiresByDefault: boolean;
    transferWithTransmittal: boolean;
}

export interface EmailSettings {
    projectEmailFolder: string;
    hasEmailSubfolders: boolean;
}

export type ProjectFolderConnectionType = "FileSystem" | "SharePointOnline";

export interface ProjectFolderConnection {
    id: string;
    name: string;
    type: ProjectFolderConnectionType;
    /** Entra tenant ID; only set for SharePointOnline connections. */
    tenantId: string | null;
    /** Entra app (client) ID used for the MSAL flow; only set for SharePointOnline connections. */
    appId: string | null;
    /** Graph drive (document library) id containing the project folder; only set for SharePointOnline. */
    driveId?: string | null;
    /** Graph drive item id of the project folder; null when the folder is the library root. */
    itemId?: string | null;
}

export interface ProjectSettingsResponse {
    submittals: SubmittalSettings;
    rfis: RfiSettings;
    actionItems: ActionItemSettings;
    transfer: TransferSettings;
    emails: EmailSettings;
    projectFolderConnections?: ProjectFolderConnection[];
    hasSharePointOnlineFolders?: boolean;
}
